import React, { useState, useRef } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import _ from "lodash";
import { getTrans as t } from "../../../Localization/translations";
import ExpenseCategoryService from "../../../services/expenses/expenseCategoryServices";
import jsPDF from "jspdf";
import { autoTable } from "jspdf-autotable";

const ExpenseCategories = ({ customerPermission }) => {
    const tableRef = React.createRef();
    const permissionss = localStorage.getItem("permissions") || "";
    const permissionsArray = permissionss.split(",");
    const navigate = useNavigate();

    const [state1, setState] = useState({
        isPaneOpen: false,
        isPaneOpenLeft: false,
    });

    const savedFilter = localStorage.getItem("expenseCatTypeFilter") || "";
    const [categoryTypeFilter, setCategoryTypeFilter] = useState(savedFilter);
    const categoryTypeFilterRef = useRef(savedFilter);

    const handleApply = () => {
        categoryTypeFilterRef.current = categoryTypeFilter;
        localStorage.setItem("expenseCatTypeFilter", categoryTypeFilter);
        tableRef.current.onQueryChange();
        setState({ isPaneOpen: false });
    };

    const handleReset = () => {
        setCategoryTypeFilter("");
        categoryTypeFilterRef.current = "";
        tableRef.current.onQueryChange();
        setState({ isPaneOpen: false });
    };

    const handleClose = () => {
        setCategoryTypeFilter(categoryTypeFilterRef.current);
        setState({ isPaneOpen: false });
    };

    const handleEdit = (id) => {
        navigate("/edit-expense-category", { state: id });
    };

    const handleView = (id) => {
        navigate("/view-expense-category", { state: id });
    };

    const handleDelete = (id) => {
        confirmAlert({
            title: "",
            message: "Are you sure you want to delete this category?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => {
                        ExpenseCategoryService.deleteCategory(id)
                            .then(() => {
                                toast.success("Category deleted successfully", {
                                    position: "top-right",
                                    autoClose: 1000,
                                    theme: "light",
                                });
                                tableRef.current.onQueryChange();
                            })
                            .catch(() => {
                                toast.error("Failed to delete category", {
                                    position: "top-right",
                                    autoClose: 1000,
                                    theme: "light",
                                });
                            });
                    },
                },
                { label: "No" },
            ],
        });
    };

    return (
        <div className="page-wrapper">
            <ToastContainer />

            <SlidingPane
                className="some-custom-class"
                overlayClassName="some-custom-overlay-class"
                isOpen={state1.isPaneOpen}
                title="Filter By"
                subtitle=""
                onRequestClose={handleClose}
            >
                <div className="col-xl-12">
                    <div className="form-group row">
                        <label className="col-lg-12 col-form-label">
                            {t("Category Type")}
                        </label>
                        <div className="col-lg-12">
                            <select
                                className="form-control"
                                value={categoryTypeFilter}
                                onChange={(e) => setCategoryTypeFilter(e.target.value)}
                            >
                                <option value="">{t("All")}</option>
                                <option value="Fee">{t("Fee")}</option>
                                <option value="Expense">{t("Expense")}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div className="col-xl-12">
                    <div className="form-group row">
                        <div className="col-lg-12 text-left" style={{ marginTop: "30px" }}>
                            <button
                                type="button"
                                className="clearReceipt btn bg-gradient-secondary ms-auto mb-0"
                                onClick={handleReset}
                            >
                                {t("RESET")}
                            </button>
                            &nbsp;&nbsp;
                            <button
                                type="button"
                                className="clearReceipt btn btn-primary ms-auto mb-0"
                                onClick={handleApply}
                            >
                                {t("Apply")}
                            </button>
                        </div>
                    </div>
                </div>
            </SlidingPane>

            <div className="content container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <MaterialTable
                            tableRef={tableRef}
                            style={{
                                backgroundColor: "var(--bs-table-bg)",
                                borderBottomWidth: "1px",
                                boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                            }}
                            title={<h5 className="d-lg-flex">{t("Fees & Expenses Categories")}</h5>}
                            columns={[
                                {
                                    title: t("Category No."),
                                    field: "id",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                    render: (rowData) => (
                                        <div
                                            // className="hyperlink"
                                            // onClick={() => handleView(rowData.id)}
                                        >
                                            {rowData.tableData.id + 1}
                                        </div>
                                    ),
                                },
                                {
                                    title: t("Category Name"),
                                    field: "category_name",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                },
                                {
                                    title: t("Category Type"),
                                    field: "category_type",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                },
                                {
                                    title: t("Fee Nature"),
                                    field: "fee_nature",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                    render: (rowData) => rowData.fee_nature || "-",
                                },
                            ]}
                            data={(query) =>
                                new Promise((resolve, reject) => {
                                    ExpenseCategoryService.getCategories(query, categoryTypeFilterRef.current)
                                        .then((res) => {
                                            const categories =
                                                res.data?.results ||
                                                res.data?.data ||
                                                res.data ||
                                                [];

                                            const total =
                                                res.data?.count ||
                                                res.data?.total ||
                                                categories.length;

                                            const currentPage = res.data?.page
                                                ? res.data.page - 1
                                                : query.page;

                                            resolve({
                                                data: categories,
                                                page: currentPage,
                                                totalCount: total,
                                            });
                                        })
                                        .catch(() => reject());
                                })
                            }

                            localization={{
                                toolbar: { searchPlaceholder: "Search Category" },
                            }}
                            actions={[
                                {
                                    icon: () => (
                                        <img
                                            src={process.env.PUBLIC_URL + "/static/images/ic-edit.svg"}
                                            alt="edit"
                                            style={{ cursor: "pointer" }}
                                        />
                                    ),
                                    tooltip: "Edit",
                                    onClick: (event, rowData) => {
                                        navigate(`/expense-categories/edit/${rowData.id}`);
                                    },
                                },
                                {
                                    icon: () => (
                                        <img
                                            src={process.env.PUBLIC_URL + "/static/images/ic-delete.svg"}
                                            alt="delete"
                                            style={{ cursor: "pointer" }}
                                        />
                                    ),
                                    tooltip: "Delete",
                                    onClick: (event, rowData) => {
                                        handleDelete(rowData.id);
                                    },
                                },
                            ]}

                            components={{
                                Toolbar: (props) => (
                                    <div className="MuiToolbar-root MTableToolbar-spacer-21 my-temp-class">
                                        <MTableToolbar {...props} />
                                        <span
                                            onClick={() => setState({ isPaneOpen: true })}
                                            style={{ color: "#b4b7c5", paddingRight: "10px", cursor: "pointer" }}
                                        >
                                            <img
                                                src={process.env.PUBLIC_URL + "/static/images/ic-filter.svg"}
                                                alt="Filter Icon"
                                            />
                                        </span>
                                        <Link className="navbar-brand m-0" to="/expense-categories/add">
                                            <button className="add-party add btn btn-primary mb-0" id="add-task">
                                                +&nbsp; {t("Add Category")}
                                            </button>
                                        </Link>
                                    </div>
                                ),
                            }}
                            options={{
                                headerStyle: {
                                    backgroundColor: "white",
                                    color: "#245C7F",
                                    fontSize: 11,
                                },
                                rowStyle: (rowData, index) => {
                                    if (index % 2) {
                                        return { backgroundColor: "#fff" };
                                    }
                                },
                                sorting: true,
                                search: true,
                                toolbar: true,
                                paging: true,
                                pageSize: 10,
                                emptyRowsWhenPaging: false,
                                pageSizeOptions: [10, 20, 25, 50],
                                paginationType: "stepped",
                                showFirstLastPageButtons: false,
                                actionsColumnIndex: -1,
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExpenseCategories;